import React, { ReactNode } from 'react';
import { useFormik } from 'formik';

import {
  Row,
  Col,
  Button,
  Modal,
  Form,
} from 'react-bootstrap';
import styled from 'styled-components';

import { Spin } from 'antd';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../utils/store.tsx';
import slice, { fields, FormikContext, initialValues, formSchema, prepareForm, prepareData } from './slice.tsx';

// enums
// import {  } from '../../../utils/utils.tsx';
// import {  } from '../../../utils/enums.tsx';

// import { ReactComponent as InfoIcon } from "../../../assets/icons/alert-info.svg";

// ----------------------------------------------------------------------

const StyledModal = styled(Modal)`
  .modal-dialog {
    min-width: 325px;
  }
`;


const FormElement = ({ onCreate, onUpdate, onDelete }: any) => {
  const { isLoading, show, index, id, details, title, path, idField, nameField } = useTypedSelector((state: RootState) => state.modalCreateItemSlice);
  const dispatch = useDispatch<AppDispatch>();


  React.useEffect(() => {
    if(show && (id && id > 0)){
      dispatch(slice.callDetailsApi(path, id, (state: boolean, data: any) => {}));
    }
  }, [id]);

  React.useEffect(() => {
    dispatch(slice.setLoading(true));
    let form = prepareForm(details, initialValues, idField, nameField);
    setValues(form);
    dispatch(slice.setLoading(false));
  }, [details]);


  const formik = useFormik({
    initialValues: initialValues,
    validateOnMount: false,
    validateOnChange: false,
    validationSchema: formSchema(null),
    onSubmit: values => {
      onSubmit(values, (data: any) => {
        onCancel();
      });
    },
  });
  const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = formik;


  const onSubmit = (values: any, callback: (data: any) => void) => {
    let data = prepareData(values, id, idField, nameField);
    if(id && id > 0){
      dispatch(slice.callUpdateApi(path, data, (state: boolean, data: any) => {
        if(state){
          if(onUpdate){
            onUpdate(index, data);
          }
          
          callback(data);
        }
      }));
    } else {
      dispatch(slice.callCreateApi(path, data, (state: boolean, data: any) => {
        if(state){
          if(onCreate){
            onCreate(index, data);
          }

          callback(data);
        }
      }));
    }
  }
  const onCancel = () => {
    let form = prepareForm(null, initialValues, idField, nameField);
    setValues(form);
    dispatch(slice.setValues(form));
    dispatch(slice.setShow({ show: false, index: null, id: null, title: '', path: '', idField: '', nameField: '' }));
    dispatch(slice.resetSlice());
  }


  const setFooter = () => {
    return <Row className='gx-12 w-100'>
      <Col xs={true}>
        {(id && id > 0) && <Button
          variant={'custom-danger'}
          size={'sm'}
          disabled={isLoading}
          onClick={() => {
            dispatch(slice.callDeleteApi(path, { [idField]: id }, (state: boolean, data: any) => {
              if(state){
                if(onDelete){
                  onDelete(index, id);
                }

                onCancel();
              }
            }));
          }}
        >Delete</Button>}
      </Col>
      <Col xs={'auto'}>
        <Button
          variant={'custom-text'}
          size={'sm'}
          disabled={isLoading}
          onClick={() => {
            onCancel();
          }}
        >Cancel</Button>
      </Col>
      <Col xs={'auto'}>
        <Button
          variant={'custom-primary'}
          size={'sm'}
          disabled={isLoading}
          onClick={() => {
            handleSubmit();
          }}
        >Save</Button>
      </Col>
    </Row>
  }

  const setForm = () => {
    return <Row className={'g-16'}>
      <Col xs={12}>
        <Form.Group>
          <Form.Label>{fields.name.label}</Form.Label>
          <Form.Control
            type={'text'}
            autoFocus={true}
            autoComplete='off'
            placeholder={fields.name.placeholder}
            disabled={false}
            value={values.name}
            onChange={(e: any) => {
              setFieldValue('name', e.target.value);
            }}
            isInvalid={!!(errors && errors.name)}
          />
          <Form.Control.Feedback type="invalid">{errors && errors.name as ReactNode}</Form.Control.Feedback>
        </Form.Group>
      </Col>
    </Row>
  }


  return <StyledModal
    className='wp-v5'
    show={show}
    onHide={() => {
      onCancel();
    }}
    backdrop={'static'}
    keyboard={false}
    enforceFocus={true}
    centered={true}
    size={'sm'}
  >
    <FormikContext.Provider value={formik}>
      <Modal.Header closeButton>
        <h6 className='fw-medium'>{((id && id > 0) ? 'Edit' : 'Add')} {title}</h6>
      </Modal.Header>

      <Spin spinning={isLoading} wrapperClassName={'no-height'}>
        <Modal.Body className='pt-24'>{setForm()}</Modal.Body>
      </Spin>

      <Modal.Footer className='px-12'>{setFooter()}</Modal.Footer>
    </FormikContext.Provider>
  </StyledModal>
}

export default FormElement;
